import { apiSlice } from "./apiSlice";
import domain from "../util/domain";
const SONGS_URL = `${domain}/api/songs`;

export const songsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCurrentSongs: builder.query({
      query: (date) => ({
        url: `${SONGS_URL}/currentsongs/${date}`,
      }),
      providesTags: ["Songs"],
    }),
    getAllSongs: builder.query({
      query: () => ({
        url: `${SONGS_URL}/allsongs`,
      }),
      providesTags: ["Songs"],
    }),
    getAllLanguages: builder.query({
      query: () => ({
        url: `${SONGS_URL}/alllanguages`,
      }),
    }),
    getAllTags: builder.query({
      query: () => ({
        url: `${SONGS_URL}/alltags`,
      }),
    }),
    getAllCategories: builder.query({
      query: () => ({
        url: `${SONGS_URL}/allcategories`,
      }),
    }),
    updateSong: builder.mutation({
      query: (songData) => ({
        url: `${SONGS_URL}/${songData.id}`,
        method: "PUT",
        body: songData,
      }),
      invalidatesTags: ["Songs"],
    }),
    addSong: builder.mutation({
      query: (songData) => ({
        url: `${SONGS_URL}`,
        method: "POST",
        body: songData,
      }),
      invalidatesTags: ["Songs"],
    }),
    getAllSongContacts: builder.query({
      query: () => ({
        url: `${SONGS_URL}/allsongcontacts`,
      }),
      providesTags: ["SongContacts"],
    }),
    updateContact: builder.mutation({
      query: (contact) => ({
        url: `${SONGS_URL}/updatesongcontacts/${contact.id}`,
        method: "PUT",
        body: contact,
      }),
      invalidatesTags: ["SongContacts"],
    }),
    addContact: builder.mutation({
      query: (contact) => ({
        url: `${SONGS_URL}/addsongcontacts`,
        method: "POST",
        body: contact,
      }),
      invalidatesTags: ["SongContacts"],
    }),
  }),
});

export const {
  // useGetCurrentSongsQuery,
  useGetAllSongsQuery,
  useGetAllLanguagesQuery,
  useGetAllTagsQuery,
  useGetAllCategoriesQuery,
  useUpdateSongMutation,
  useAddSongMutation,
  useGetAllSongContactsQuery,
  useUpdateContactMutation,
  useAddContactMutation,
} = songsApiSlice;